import { BuybackSection } from '@/components/dashboard/BuybackSection'

// Buyback its own page again (founder call): the daily open-market repurchase is a standing
// mechanism with its own live figures + a permissionless keeper trigger, not a footnote under the
// protocol-stats overview it had been folded into. BuybackSection carries its own SectionHeader,
// so this page is just the standard width wrapper around it.
export function BuybackPage() {
  return (
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: '24px' }}>
      <BuybackSection />
    </div>
  )
}
